module.exports = __webpack_public_path__ + "static/img/icon_4.a55328f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_4.png
// module id = l1Dj
// module chunks = 8